import React, { Suspense } from "react";
import { withTranslation } from "react-i18next";
import Login from "./Login";
import { getParameter } from "../util/util";

function TabTitle(props) {
  return props.isActive === props.dataTab ? (
    <li
      onClick={props.onClick}
      className="tab-title tab-title--active"
      data-tab={props.dataTab}
      id={props.title}
    >
      {props.title}
    </li>
  ) : (
    <li
      onClick={props.onClick}
      className="tab-title"
      data-tab={props.dataTab}
      id={props.title}
    >
      {props.title}
    </li>
  );
}

function TabContent(props) {
  return (
    <div style={props.style} data-tab={props.dataTab}>
      {props.content}
    </div>
  );
}

class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: "1",
      showResetPassword: false,
      showReCaptcha: false,
      userType: "",
      data: [
        {
          id: "1",
          tabTitle: getParameter("pu") === "N" ? null : "user_login",
          tabContent: (
            <Login
              setShowCC={this.props.setShowCC}
              setShowResetPassword={this.props.setShowResetPassword}
              userType={this.props.userType}
              handleModalOpen={this.props.handleModalOpen}
              handleSendNewCode={this.props.handleSendNewCode}
            // LoginhandleResendCode={this.props.TabhandleResendCode}
            // LoginSendACode={this.props.TabhandleSendACode}
            // setGlobalState={this.props.setGlobalState}
            // globalState={this.props.globalState}
            />
          ),
        },
      ],
    };
    this.changeActive = this.changeActive.bind(this);
  }

  changeActive(ev) {
    this.setState({ isActive: ev.target.getAttribute("data-tab") });
  }

  render() {
    const { t } = this.props;
    const accountType = getParameter("account_type");
    var listTitle = this.state.data.map((item) => (
      <TabTitle
        id={item.id}
        key={item.id}
        isActive={this.state.isActive}
        onClick={this.changeActive}
        dataTab={item.id}
        title={t(item.tabTitle)}
      />
    ));
    var listContent = this.state.data.map((item) =>
      this.state.isActive === item.id ? (
        <TabContent key={item.id} dataTab={item.id} content={item.tabContent} />
      ) : (
        <TabContent
          key={item.id}
          style={{ display: "none" }}
          dataTab={item.id}
          content={item.tabContent}
        />
      )
    );
    return (
      <div className="loginPage">
        <section className="login_form">
          <div className="loginIntroTextContainer">
            {accountType == "business" ? (
              <h3>{t("welcome_business")} </h3>
            ) : (getParameter("pu") === "N" ? null :
              <h3>{t("welcome")} </h3>
            )}

            {getParameter("pu") === "N" ? null : <p className="headerdescription">{t("welcome_des")} </p>}
          </div>
          <div className="tabs">
            <ul className="tabs-titles">{listTitle}</ul>
            <div className="tab-content">{listContent}</div>
          </div>
        </section>
      </div>
    );
  }
}
export default withTranslation()(Tabs);